exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.shop_detail_map{\n  position:relative;\n}\n.shop_detail_map .map{\n  position:absolute;\n  top:40px;\n  left:0;\n  width:100%;\n}\n", ""]);

// exports
